import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { IconButton, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { TableColumn } from "react-data-table-component";
import { useLocation, useNavigate } from "react-router-dom";
import AutocompleteSelect from "../../../../ui/components/autocomplete-select/autocomplete-select";
import Table from "../../../../ui/components/table/table";
import { Convenio } from "../../../models/convenio";
import { ListModel } from "../../../models/list-model";
import { convenioServices } from "../../../services/convenio.services";
import { obrasocialServices } from "../../../services/obra-social.services";
import { getFormattedDate } from "../../../utils/common.utils";
import {
  initialFilter,
  queryParamsConfig,
} from "../../../utils/convenio.utils";
import { useQueryParamsReplace } from "../../../utils/useQueryParamsReplace";
import "./convenios-list.scss";

export default function ConveniosList() {
  const [queryParams, setQueryParams] =
    useQueryParamsReplace(queryParamsConfig);
  const [fetching, setFetching] = useState<boolean>(true);
  const [entities, setEntities] = useState<Convenio[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const navigate = useNavigate();
  const location = useLocation();
  const [obrasSociales, setObrasSociales] = useState<ListModel[]>([]);

  const getObrasSociales = async () => {
    obrasocialServices
      .lookup()
      .then((response) => {
        const items: ListModel[] = [];
        response.data.forEach((element: any) => {
          items.push({
            value: element.id,
            label: element.value,
          });
        });
        setObrasSociales(items);
      })
      .catch((error) => {});
  };

  useEffect(() => {
    if (location.search === "") {
      setQueryParams(initialFilter);
    }
    if (queryParams.page) {
      getConvenios();
    }
  }, [queryParams]);

  useEffect(() => {
    getObrasSociales();
  }, []);

  const getConvenios = async () => {
    let params = { ...queryParams };
    params = { ...params, active: true };
    setFetching(true);
    convenioServices
      .getList(params)
      .then((response) => {
        setFetching(false);
        setEntities(response.data.items);
        setTotalCount(response.data.totalItems);
      })
      .catch((error) => {});
  };

  const columns: TableColumn<Convenio>[] = [
    {
      name: "Obra Social",
      selector: (row) => row.obraSocialNombre,
      sortable: true,
      sortField: "obra_social",
    },
    {
      name: "Convenio",
      selector: (row) => row.nombre,
    },
    {
      name: "Fecha Inicio",
      selector: (row) => getFormattedDate(row.fechaInicio.toString()),
      sortable: true,
      sortField: "fecha_inicio",
    },
    {
      name: "Fecha Fin",
      selector: (row) =>
        row.fechaFin ? getFormattedDate(row.fechaFin.toString()) : "-",
      sortable: true,
      sortField: "fecha_fin",
    },
    {
      name: "",
      button: true,
      cell: (row) => (
        <>
          <Tooltip title="Ver">
            <IconButton aria-label="ver" onClick={() => goToView(row)}>
              <VisibilityOutlinedIcon />
            </IconButton>
          </Tooltip>
        </>
      ),
      width: "5%",
      style: {
        position: "sticky",
        right: 0,
        backgroundColor: "#fff",
        zIndex: 1,
      },
    },
  ];

  const goToView = (row: Convenio) => {
    navigate(`view/${row.id}`);
  };

  return (
    <div className="convenios-list-container">
      <div className="row action-button">
        <AutocompleteSelect
          name="obraSocialId"
          label="Obra Social"
          isMultiple={false}
          options={obrasSociales}
          value={queryParams.obraSocialId || ""}
          onChange={(value) => {
            setQueryParams({
              ...queryParams,
              obraSocialId: value !== "" ? value : undefined,
            });
          }}
        ></AutocompleteSelect>
      </div>
      <div className="row">
        <div className="convenios-table">
          <Table
            table={{
              columns,
              data: entities,
              paginationTotalRows: totalCount,
              pointerOnHover: true,
              highlightOnHover: true,
              onRowClicked: goToView,
            }}
            setQueryParams={setQueryParams}
            queryParams={queryParams}
          ></Table>
        </div>
      </div>
    </div>
  );
}
